function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { Action } from "../../internal/Action.js";
import { toFloatAsString } from "../../internal/utils/toFloatAsString.js";
import { AspectRatioQualifierValue } from "../../qualifiers/aspectRatio/AspectRatioQualifierValue.js";
import { ignoreInitialAspectRatio, regionRelative as _regionRelative, relative as _relative } from "../../qualifiers/flag.js";
import { FlagQualifier } from "../../qualifiers/flag/FlagQualifier.js";
import { ACTION_TYPE_TO_CROP_MODE_MAP, CROP_MODE_TO_ACTION_TYPE_MAP } from "../../internal/internalConstants.js";
/**
 * @description Defines a resize using width and height.
 * @extends SDK.Action
 * @memberOf Actions.Resize
 * @see Visit {@link Actions.Resize| Resize} for examples
 */

var ResizeSimpleAction = /*#__PURE__*/function (_Action) {
  _inherits(ResizeSimpleAction, _Action);

  var _super = _createSuper(ResizeSimpleAction);

  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  function ResizeSimpleAction(cropType, cropWidth, cropHeight) {
    var _this;

    _classCallCheck(this, ResizeSimpleAction);

    _this = _super.call(this);
    _this._actionModel = {
      dimensions: {}
    };
    _this._actionModel.actionType = CROP_MODE_TO_ACTION_TYPE_MAP[cropType] || cropType;

    _this.addQualifier(new Qualifier('c', cropType));

    cropWidth && _this.width(cropWidth);
    cropHeight && _this.height(cropHeight);
    return _this;
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */


  _createClass(ResizeSimpleAction, [{
    key: "height",
    value: function height(x) {
      this._actionModel.dimensions.height = x;
      return this.addQualifier(new Qualifier('h', x));
    }
    /**
     * @description Sets the width of the resize
     * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
     */

  }, {
    key: "width",
    value: function width(x) {
      this._actionModel.dimensions.width = x;
      return this.addQualifier(new Qualifier('w', x));
    }
    /**
     * @description Sets the aspect ratio of the asset.
     * For a list of supported types see {@link Qualifiers.AspectRatio|
      * AspectRatio values}
     * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
     * @return {this}
     */

  }, {
    key: "aspectRatio",
    value: function aspectRatio(ratio) {
      // toFloatAsString is used to ensure 1 turns into 1.0
      if (ratio instanceof AspectRatioQualifierValue) {
        this._actionModel.dimensions.aspectRatio = "".concat(ratio);
        return this.addQualifier(new Qualifier('ar', ratio));
      }

      if (typeof ratio === 'number' || typeof ratio === 'string') {
        this._actionModel.dimensions.aspectRatio = toFloatAsString(ratio);
        return this.addQualifier(new Qualifier('ar', toFloatAsString(ratio)));
      }

      if (ratio instanceof FlagQualifier) {
        this._actionModel.dimensions.aspectRatio = "".concat(ratio.qualifierValue);
        return this.addFlag(ratio);
      }
    }
    /**
     * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
     * @return {this}
     */

  }, {
    key: "relative",
    value: function relative() {
      this._actionModel.relative = true;
      return this.addFlag(_relative());
    }
    /**
     * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
     * @return {this}
     */

  }, {
    key: "regionRelative",
    value: function regionRelative() {
      this._actionModel.regionRelative = true;
      return this.addFlag(_regionRelative());
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var actionType = actionModel.actionType,
          dimensions = actionModel.dimensions,
          relative = actionModel.relative,
          regionRelative = actionModel.regionRelative;
      var aspectRatio = dimensions.aspectRatio,
          width = dimensions.width,
          height = dimensions.height;
      var cropMode = ACTION_TYPE_TO_CROP_MODE_MAP[actionType] || actionType; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(cropMode, width, height);
      aspectRatio && result.aspectRatio(aspectRatio === 'ignore_aspect_ratio' ? ignoreInitialAspectRatio() : aspectRatio);
      relative && result.relative();
      regionRelative && result.regionRelative();
      return result;
    }
  }]);

  return ResizeSimpleAction;
}(Action);

export { ResizeSimpleAction };